<template>
    <div>

        <rkm-area
            type="fieldset"
            title="Filtros"
        >

            <rkm-form
                ref="Form"
            >

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            v-model="model.periodo"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="agendamentoExame"
                            label="Exame"
                            show-default-option
                            text-field="nome"
                            v-model="model.exameId"
                            value-field="id"
                            default-option-text="Todos"
                            @change="handleExame()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row class="flex-nowrap">

                    <rkm-col cols="auto">
                        <rkm-form-checkbox-group
                            label="Status"
                            v-model="model.statusId"
                            :options="model.status"
                            :validations="validations.status"
                            text-field="nome"
                            value-field="id"
                            buttons
                            button-color="outline-primary"
                            @change="handleStatus()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeSolicitante"
                            :validations="validations.unidade"
                            label="Unidade solicitante"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="unidadeId"
                            default-option-text="Selecione"
                            @change="handleUnidadeSolicitante()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="infraestruturas"
                            textField="nome"
                            v-model="model.infraestruturaId"
                            valueField="id"
                            show-default-option
                            default-option-text="Todos"
                            @change="handleUnidadeSolicitante()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeColeta"
                            label="Local de coleta"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.coletaUnidadeId"
                            value-field="unidadeId"
                            default-option-text="Todos"
                            @change="handleColeta()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="coletaInfraestruturas"
                            textField="nome"
                            v-model="model.coletaInfraestruturaId"
                            valueField="id"
                            show-default-option
                            default-option-text="Todos"
                            @change="handleColeta()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="unidadeLaboratorio"
                            label="Laboratório"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.laboratorioId"
                            value-field="unidadeId"
                            default-option-text="Todos"
                            @change="loadFields()"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            label="Local de atendimento"
                            :options="laboratorioInfraestruturas"
                            textField="nome"
                            v-model="model.laboratorioInfraestruturaId"
                            valueField="id"
                            show-default-option
                            default-option-text="Todos"
                            @change="loadFields()"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="Agendamento"
                            v-model="model.agendamentoId"
                            number
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            label="Prontuário"
                            v-model="model.prontuario"
                            number
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            v-if="itemsNotSave"
            no-margin-top
            title="Resultado"
        >

            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    :disabled="itemsNotSave.length === 0"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>
                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>
                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>
                <rkm-button
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                    :disabled="itemsNotSave.length === 0"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itemsNotSave.length === 0"
                    @click="exportTo"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>
        </rkm-area>

        <template v-if="itemsNotSave && itemsNotSave.length > 0">

            <div
                v-for="(item, index) in itemsNotSave"
                class="mt-3"
                :key="index"
            >

                <template>
                    <div class="table-th text-center coleta">
                        Unidade de coleta: {{ item.coletaNomeFantasia }} -
                        Local de atendimento: {{ item.coletaInfraestruturaNome }}
                    </div>
                </template>

                <div
                    v-for="(item, index) in item.agendamentos"
                    class="mb-3"
                    :key="index"
                >

                    <rkm-table
                        :items="item.exames"
                        :fields="fields"
                        hide-filters
                        sort-by="nome"
                        hide-pagination
                        class="table-agendamento"
                    >

                        <template #thead-top>

                            <rkm-tr>
                                <rkm-th
                                    :colspan="selectedCols.length + 4"
                                >
                                    Paciente: {{ item.pacienteNome }}
                                    <span v-if="item.prefereNomeSocial">
                                        <strong>({{ item.pacienteNomeSocial }})</strong>
                                    </span>

                                    - Prontuário: {{ item.pacienteProntuario }}
                                    - Agendamento: {{ item.agendamentoNumero }}
                                </rkm-th>
                            </rkm-tr>
                        </template>

                        <template #afterTable>
                            <div class="table-th text-right">
                                Total de exames: {{ item.exames.length }}
                            </div>
                        </template>
                    </rkm-table>
                </div>

                <template>
                    <div class="table-th coleta text-right">
                        Total de exames da unidade de coleta: {{ item.coletaNomeFantasia }} -
                        Local de atendimento: {{ item.coletaInfraestruturaNome }}: {{ item.totalExames }}
                    </div>
                </template>
            </div>
        </template>

        <template v-if="itemsNotSave && itemsNotSave.length == 0">

            <rkm-table
                :items="itemsNotSave"
                :fields="fields"
                hide-filters
                sort-by="nome"
                hide-pagination
            />
        </template>

        <template>
            <rkm-row v-if="itemsNotSave && itemsNotSave.length > 0">

                <rkm-col
                    cols="12"
                >
                    <rkm-area
                        title="Status dos exames"
                        type="fieldset"
                    >
                        <rkm-row>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.AGENDADO)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Agendado"
                                    :disabled="true"
                                    v-model="model.agendado"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.NAO_REALIZADO)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Não coletado"
                                    :disabled="true"
                                    v-model="model.naoColetado"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.REALIZADO)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Coleta realizada"
                                    :disabled="true"
                                    v-model="model.coletaRealizada"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.PENDENTE_ASSINATURA)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Pendente de assinatura"
                                    :disabled="true"
                                    v-model="model.pendenteAssinatura"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.ASSINADO)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Pendente de impressão"
                                    :disabled="true"
                                    v-model="model.pendenteImpressao"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.PENDENTE_ENTREGA)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Pendente de entrega"
                                    :disabled="true"
                                    v-model="model.pendenteEntrega"
                                />
                            </rkm-col>

                            <rkm-col
                                v-if="model.statusId.find(id => id == enums.statusAgendamento.ENTREGUE)"
                                class="flex-grow-1"
                            >
                                <rkm-form-input
                                    label="Entregue"
                                    :disabled="true"
                                    v-model="model.entregue"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { repository, error, object, formats, data, stringCase, file } from '@/mixins'

// Moment.
import moment from 'moment'

// Enums.
import statusAgendamento from '@/enums/exame-laboratorial/statusAgendamento'
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Filters.
import format from '@/filters/formats'

export default {
    computed: {
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
                status: { required: true },
                unidade: { required: true}
            }
        },
        infraestruturas() {

            if (this.model.unidadeId && this.unidadeSolicitante.length > 0) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        coletaInfraestruturas() {

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
        laboratorioInfraestruturas() {

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                return infraestruturaPrincipal
            }

            return []
        },
    },
    created() {

        this.repositories = {
            exame: this.getConectaSusRepository('exameLaboratorial.exameSolicitadoStatus'),
            impressao: this.getConectaSusRepository('impressao.exameLaboratorial'),
            exportacao: this.getConectaSusRepository('exportacao.exameLaboratorial'),
        },

        this.load();
    },
    data() {
        return {
            model: {
                prontuario: null,
                agendamentoId: null,
                unidadeId: null,
                infraestruturaId: null,
                coletaUnidadeId: null,
                coletaInfraestruturaId: null,
                laboratorioId: null,
                laboratorioInfraestruturaId: null,
                exameId: null,
                exameNome: null,
                grupos: null,
                status: [],
                statusId: [],
                statusSelecionado: [],
                periodo: {
                    start: null,
                    end: null,
                },
                agendado: 0,
                coletaRealizada: 0,
                naoColetado: 0,
                pendenteAssinatura: 0,
                pendenteImpressao: 0,
                pendenteEntrega: 0,
                entregue: 0,
            },
            agendamentoExame: [],
            unidadeSolicitante: [],
            unidadeColeta: [],
            unidadeLaboratorio: [],
            itemsNotSave: null,
            enums: {
                statusAgendamento,
                preferenciaNome
            },
            indeterminate: false,
            filterDefault: {},
            selectedAll: false,
            columns: [
                { key: 'dataAgendamento', label: 'Data agendamento', sortable: true, class: 'col-min text-center', fixed: true },
                { key: 'dataColeta', label: 'Data coleta', sortable: true, class: 'col-min text-center', fixed: true },
                { key: 'agendamentoNumero', label: 'Agendamento', sortable: true, class: 'col-min text-center' },
                { key: 'exameNome', label: 'Exame', sortable: true, fixed: true },
                { key: 'procedimento', label: 'Procedimento', class: 'col-min text-center', sortable: true },
                { key: 'status', label: 'Status', sortable: true, class: 'col-min', fixed: true },
                { key: 'unidade', label: 'Unidade solicitante', sortable: true, },
                { key: 'infraestruturaNome', label: 'Local de atendimento solicitante', sortable: true },
                { key: 'unidadeColeta', label: 'Unidade coleta', sortable: true },
                { key: 'coletaInfraestruturaNome', label: 'Local de atendimento coleta', sortable: true },
                { key: 'laboratorio', label: 'Laboratório', sortable: true },
                { key: 'laboratorioInfraestruturaNome', label: 'Local de atendimento laboratório', sortable: true },
            ],
            selectedCols: [],
        }
    },
    mixins: [repository, error, object, formats, data, file, stringCase],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'inicio' || key === 'fim') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        load() {

            this.model.periodo = this.data.form.periodo

            this.setStatus()
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioExameSolicitadoStatus(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioExameSolicitadoStatus(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        prepareDataWithColumns() {

            const data = this.prepareData()

            data.selectedCols = this.fields.map(f => ({
                key: this.camelToSnake(f.key),
                label: f.label,
                class: f.class
            }))

            return data
        },
        prepareData() {

            const data = this.clone(this.model)

            if (this.model.exameId) {

                data.exameNome = this.agendamentoExame.find(u => u.id == this.model.exameId).nome
            }

            if (this.model.unidadeId) {

                data.unidadeNome = this.data.form.unidades.find(u => u.id == data.unidadeId).nomeFantasia
            }

            if (data.infraestruturaId) {

                data.infraestruturaNome = this.infraestruturas.find(u => u.id == data.infraestruturaId).nome
            }

            if (data.coletaUnidadeId) {

                data.coletaUnidadeNome = this.unidadeColeta.find(u => u.unidadeId == data.coletaUnidadeId).nomeFantasia
            }

            if (data.coletaInfraestruturaId) {

                data.coletaInfraestruturaNome = this.coletaInfraestruturas.find(u => u.id == data.coletaInfraestruturaId).nome
            }

            if (data.laboratorioId) {

                data.laboratorioNome = this.unidadeLaboratorio.find(u => u.unidadeId == data.laboratorioId).nomeFantasia
            }

            if (data.laboratorioInfraestruturaId) {

                data.laboratorioInfraestruturaNome = this.laboratorioInfraestruturas.find(u => u.id == data.laboratorioInfraestruturaId).nome
            }

            data.statusId.forEach(status => {

                const selecionado = data.status.find(u => u.id == status)

                if (status) {

                    data.statusSelecionado.push({

                        id: selecionado.id,
                        nome: selecionado.nome,
                    })
                }
            })

            this.formateDates(data.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(data)
        },
        search() {

            this.setLoading()

            this.repositories.exame.list(this.getSearchParams())
                .then(({ data }) => {

                    this.itemsNotSave = data.model.unidadeColeta

                    this.model.agendado = data.form.agendado
                    this.model.naoColetado = data.form.naoColetado
                    this.model.coletaRealizada = data.form.coletaRealizada
                    this.model.pendenteAssinatura = data.form.pendenteAssinatura
                    this.model.pendenteImpressao = data.form.pendenteImpressao
                    this.model.pendenteEntrega = data.form.pendenteEntrega
                    this.model.entregue = data.form.entregue
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params.periodo, ['start', 'end'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        resetForm() {

            this.model.exameId = null
            this.model.prontuario = null
            this.model.agendamentoId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null
            this.itemsNotSave = null

            this.setStatus()
            this.setDefaultValues()

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        setStatus() {

            this.model.statusId = [
                this.enums.statusAgendamento.AGENDADO,
                this.enums.statusAgendamento.NAO_REALIZADO,
                this.enums.statusAgendamento.REALIZADO,
                this.enums.statusAgendamento.PENDENTE_ASSINATURA,
                this.enums.statusAgendamento.ASSINADO,
                this.enums.statusAgendamento.PENDENTE_ENTREGA,
                this.enums.statusAgendamento.ENTREGUE,
            ]

            this.model.status = [
                {
                    "id": this.enums.statusAgendamento.AGENDADO,
                    "nome": "AGENDADO",
                },
                {
                    "id": this.enums.statusAgendamento.NAO_REALIZADO,
                    "nome": "NÃO COLETADO",
                },
                {
                    "id": this.enums.statusAgendamento.REALIZADO,
                    "nome": "COLETA REALIZADA",
                },
                {
                    "id": this.enums.statusAgendamento.PENDENTE_ASSINATURA,
                    "nome": "PENDENTE DE ASSINATURA",
                },
                {
                    "id": this.enums.statusAgendamento.ASSINADO,
                    "nome": "PENDENTE DE IMPRESSÃO",
                },
                {
                    "id": this.enums.statusAgendamento.PENDENTE_ENTREGA,
                    "nome": "PENDENTE DE ENTREGA",
                },
                {
                    "id": this.enums.statusAgendamento.ENTREGUE,
                    "nome": "ENTREGUE",
                },
            ]
        },
        setDefaultValues() {

            this.model.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        setListagem() {

            this.itemsNotSave = null
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleInfraestrutura(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {

                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {

                this.model.infraestruturaId = null
            }
        },
        handleColetaInfraestrutura(infraestruturaColetaPrincipal) {

            if (infraestruturaColetaPrincipal.find(u => u.principal === true)) {

                this.model.coletaInfraestruturaId = infraestruturaColetaPrincipal.find(u => u.principal === true).id
            }
        },
        handleLaboratorioInfraestrutura(infraestruturaLaboratorioPrincipal) {

            if (infraestruturaLaboratorioPrincipal.find(u => u.principal === true)) {

                this.model.laboratorioInfraestruturaId = infraestruturaLaboratorioPrincipal.find(u => u.principal === true).id
            }
        },
        setInfraestrutura() {

            this.model.infraestruturaId = null
        },
        setColetaInfraestrutura() {

            this.model.coletaInfraestruturaId = null
        },
        setLaboratorioInfraestrutura() {

            this.model.laboratorioInfraestruturaId = null
        },
        loadFields() {

            this.setLoading()

            this.setListagem()

            this.repositories.exame.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.loadUnidadeSolicitante(data.model.unidades)
                    this.loadUnidadeColeta(data.model.coletas)
                    this.loadLaboratorio(data.model.laboratorios)
                    this.loadExame(data.model.exames)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadUnidadeSolicitante(agendamento) {

            const unidades = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.unidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.infraestruturaId).principal

                const unidadeInserida = unidades.find(u => u.unidadeId
                    === infraestrutura.unidadeId)

                if (unidadeInserida) {

                    let verifyUnidade = unidadeInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.infraestruturaId)

                    if (!verifyUnidade) {

                        unidadeInserida.infraestruturas.push({

                            id: infraestrutura.infraestruturaId,
                            nome: infraestrutura.infraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    unidades.push({

                        unidadeId: infraestrutura.unidadeId,
                        nomeFantasia: infraestrutura.unidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.infraestruturaId,
                                nome: infraestrutura.infraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeSolicitante = unidades
        },
        loadUnidadeColeta(agendamento) {

            const coleta = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.coletaUnidadeId).infraestruturas.find(u => u.id
                        === infraestrutura.coletaInfraestruturaId).principal

                const coletaInserida = coleta.find(u => u.unidadeId
                    === infraestrutura.coletaUnidadeId)

                if (coletaInserida) {

                    let verifyUnidade = coletaInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.coletaInfraestruturaId)

                    if (!verifyUnidade) {

                        coletaInserida.infraestruturas.push({

                            id: infraestrutura.coletaInfraestruturaId,
                            nome: infraestrutura.coletaUnidadeNome,
                            principal: principal,
                        })
                    }

                } else {

                    coleta.push({

                        unidadeId: infraestrutura.coletaUnidadeId,
                        nomeFantasia: infraestrutura.coletaUnidadeNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.coletaInfraestruturaId,
                                nome: infraestrutura.coletaInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeColeta = coleta
        },
        loadLaboratorio(agendamento) {

            const laboratorio = []

            agendamento.map(infraestrutura => {

                let principal = this.data.form.unidades.find(u => u.id ===
                    infraestrutura.laboratorioId).infraestruturas.find(u => u.id
                        === infraestrutura.laboratorioInfraestruturaId).principal

                const laboratorioInserida = laboratorio.find(u => u.unidadeId
                    === infraestrutura.laboratorioId)

                if (laboratorioInserida) {

                    let verifyUnidade = laboratorioInserida.infraestruturas.find(u => u.id ===
                        infraestrutura.laboratorioInfraestruturaId)

                    if (!verifyUnidade) {

                        laboratorioInserida.infraestruturas.push({

                            id: infraestrutura.laboratorioInfraestruturaId,
                            nome: infraestrutura.laboratorioInfraestruturaNome,
                            principal: principal,
                        })
                    }

                } else {

                    laboratorio.push({

                        unidadeId: infraestrutura.laboratorioId,
                        nomeFantasia: infraestrutura.unidadeLaboratorioNome,
                        infraestruturas: [
                            {
                                id: infraestrutura.laboratorioInfraestruturaId,
                                nome: infraestrutura.laboratorioInfraestruturaNome,
                                principal: principal,
                            }
                        ]
                    })
                }
            })

            this.unidadeLaboratorio = laboratorio
        },
        loadExame(agendamento) {

            const exameCadastrado = []

            agendamento.map(exames => {

                exames.exames.map(exame => {

                    const exameInserido = exameCadastrado.find(u => u.id == exame.id)

                    if (!exameInserido) {

                        exameCadastrado.push({

                            id: exame.id,
                            nome: exame.nome,
                        })
                    }
                })
            })

            if (exameCadastrado) {

                exameCadastrado.sort((a,b) => (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0));
            }

            this.agendamentoExame = exameCadastrado

            let exameSelecionado = this.agendamentoExame.find(u => u.id == this.model.exameId)

            if (!exameSelecionado) {

                this.model.exameId = null
            }
        },
        handlePeriodo() {

            this.model.exameId = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleExame() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleStatus() {

            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleUnidadeSolicitante() {

            this.model.coletaUnidadeId = null
            this.model.coletaInfraestruturaId = null
            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        },
        handleColeta() {

            this.model.laboratorioId = null
            this.model.laboratorioInfraestruturaId = null

            this.loadFields()
        }
    },
    filters: {
        ...format,
    },
    props: {
        data: { type: Object, required: true }
    },
    watch: {
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
        'model.periodo.start'() {

            if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.periodo.end'() {

           if (this.model.periodo.start && this.model.periodo.end) {

                this.handlePeriodo()
            }
        },
        'model.unidadeId'() {

            this.setInfraestrutura()

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.unidadeSolicitante.find(u => u.unidadeId == this.model.unidadeId).infraestruturas

                this.handleInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.coletaUnidadeId'() {

            this.setColetaInfraestrutura()

            if (this.model.coletaUnidadeId) {

                let infraestruturaPrincipal = this.unidadeColeta.find(u => u.unidadeId == this.model.coletaUnidadeId).infraestruturas

                this.handleColetaInfraestrutura(infraestruturaPrincipal)
            }
        },
        'model.laboratorioId'() {

            this.setLaboratorioInfraestrutura()

            if (this.model.laboratorioId) {

                let infraestruturaPrincipal = this.unidadeLaboratorio.find(u => u.unidadeId == this.model.laboratorioId).infraestruturas

                this.handleLaboratorioInfraestrutura(infraestruturaPrincipal)
            }
        },
    }
}
</script>

<style scoped>
.table-th {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
    border-top: 1px solid #dee2e6;
    border-left: 1px solid #dee2e6;
    border-right: 1px solid #dee2e6;
}
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    border-top: 1px solid #ccc;
    font-weight: 600;
}
.table-border-top {
    border-top: 0;
    height: 30px;
    padding: 0;
}
.table-agendamento >>> .col-width {
    width: 16%;
}
.coleta {
    background: #e9e9e9;
}
</style>